import { ChannelIcon, MultiSelect } from '@weareopenr/component-library';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';

type ChannelFilterProps = {
  options: SelectedMultiOption[];
  selected: string[];
  onChange: (channels: string[]) => void;
};

export const ChannelFilter = ({ options, selected, onChange }: ChannelFilterProps) =>
  options.length > 0 ? (
    <MultiSelect Icon={ChannelIcon} label="Channels" options={options} selected={selected} onChange={onChange} />
  ) : null;
